import { NextPage } from "next";
import { Layout } from "@kursk/components/Layout/Layout";
import React from "react";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { touristRoutesSlice } from "@common/redux/slices/touristroutes.slice";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { HeaderBlock } from "@kursk/components/ui/HeaderBlock/HeaderBlock";
import styles from "./SingleTouristsRoutes.module.scss";
import { SocialLinks } from "@kursk/components/ui/SocialLinks/SocialLinks";
import { ContentBlock } from "@kursk/components/ui/ContentBlock/ContentBlock";
import { Tags } from "@kursk/components/ui/Tags/Tags";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { PointsList } from "@kursk/components/pages/SingleTouristRoutes/PointsList/PointsList";
import { RouteInfoBlock } from "@kursk/components/pages/SingleTouristRoutes/RouteInfoBlock/RouteInfoBlock";
import { YandexMap } from "@kursk/components/ui/YandexMap/YandexMap";
import { StepperBlock } from "@kursk/components/ui/StepperBlock/StepperBlock";
import { AudioBlock } from "@kursk/components/ui/AudioBlock/AudioBlock";
import { AudioProvider } from "@kursk/context/audio.context";
import { regionContent } from "@kursk/content/regionContent";
import { FeedbacksBlock } from "@kursk/components/ui/FeedbacksBlock/FeedbacksBlock";

export const SingleTouristsRoutes: NextPage = () => {
  const { touristRoute } = useSelectSlice(touristRoutesSlice);
  const { forTouristRoutesRoutes } = useSelectSlice(recommendationSlice);
  const stepID = 'step-item-';
  if (!touristRoute) {
    return <></>;
  }
  const getPoints = () => touristRoute.points.map((point, index): {
    content: number;
    coords: number[];
    id: string;
    onClick: () => void;
  } => ({
    coords: point.type === 'place' ?
      point.place.mapPosition.coordinates : point.location.mapPosition.coordinates,
    id: String(Math.random()).slice(2),
    content: index + 1,
    onClick: () => document.getElementById(`${stepID}${index}`).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    }),
  }));

  return (
    <Layout key={`touristRoute_${touristRoute._id}`}>
      <AudioProvider>
        <>
          <SeoMetaTitles page="singleRoute"
            entity={{ name: touristRoute.name, seo: touristRoute.seo, image: touristRoute.image }}
            showOgImage={true}/>
          <section className={styles.routes_header}>
            <HeaderBlock
              entityType={'touristroutes'}
              entity={touristRoute}
              goBack={'/touristroutes'}
              goBackTitle={`вернуться к списку ${regionContent.entitiesNames.touristroutes.pluralGenitive}`}/>
          </section>
          <section className={styles.routes_socialLinks}>
            <SocialLinks/>
          </section>
          <section className={styles.routes_content}>
            <PointsList points={touristRoute.points} stepID={stepID}/>
          </section>
          <section className={styles.routes_info}>
            <RouteInfoBlock routeType={touristRoute.routeType} duration={touristRoute.duration}/>
          </section>
          {touristRoute.audio && <section className={styles.routes_audio}>
            <AudioBlock audio={touristRoute.audio}/>
          </section>}
          <section className={styles.routes_content}>
            <ContentBlock content={touristRoute?.content} source={touristRoute.source}/>
          </section>
          <section className={styles.routes_map}>
            <YandexMap
              height={480}
              points={getPoints()}
              polyline={touristRoute.polyline.points}
              mapState={{
                center: [55.751574, 37.573856],
                zoom: 10,
              }}
            />
          </section>
          <section className={styles.routes_stepper}>
            <StepperBlock points={touristRoute.points} stepID={stepID} type="route"/>
          </section>
          <section className={styles.routes_tags}>
            <Tags link={'/touristroutes'} className={styles.routes_inner} tags={touristRoute?.tags}/>
          </section>
          <section>
            <FeedbacksBlock entity={touristRoute} entityType={'touristroutes'}/>
          </section>
          <section className={styles.routes_recommendations}>
            <RecommendationsBlock
              entityType="touristroutes"
              data={forTouristRoutesRoutes}
              title={'также рекомендуем'}
              goTo={'/touristroutes'}
              goToTitle={`все ${regionContent.entitiesNames.touristroutes.plural}`}/>
          </section>
          <section className={styles.routes_socials}>
            <Socials/>
          </section>
        </>
      </AudioProvider>
    </Layout>
  )
}
